
<template>
  <footer class="site-footer py-4">
    <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center">
      <div class="footer-left mb-3 mb-md-0">

      </div>
      <div class="footer-right d-flex gap-4 align-items-center">
        <a href="#" class="footer-link">Create Ticket</a>
        <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
        <router-link to="/terms" class="footer-link">Terms & Conditions</router-link>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer-right {
    gap: 2rem !important; /* Increased gap for better readability */
}

.site-footer {
    background: #0f0e17;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-link {
    color: #6b7280;
    text-decoration: none;
    font-size: 0.85rem;
    transition: color 0.2s;
}

.footer-link:hover {
    color: #fff;
}

.toplist-link {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
}
</style>
